import type { ImgHTMLAttributes } from 'react'

export interface OptimizedImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  /** Above-the-fold images: eager load + high fetch priority (no visual change). */
  priority?: boolean
}

/**
 * Thin wrapper around <img> with browser-friendly defaults.
 * Property filenames are timestamped, so long HTTP cache + stable src is safe.
 */
export function OptimizedImage({
  priority = false,
  loading,
  decoding = 'async',
  fetchPriority,
  ...props
}: OptimizedImageProps) {
  return (
    <img
      {...props}
      loading={loading ?? (priority ? 'eager' : 'lazy')}
      decoding={decoding}
      fetchPriority={fetchPriority ?? (priority ? 'high' : undefined)}
    />
  )
}
